export const AccordionElementWidgetId = 'AccordionElementWidget';

export enum AccordionElementWidgetAttributes {
  HEADLINE = 'headline',
  SUB_HEADLINE = 'subHeadline',
  TEXT = 'text',
  ID = 'accordionId',
  IMAGE_BEFORE = 'imageBefore',
  IMAGE_AFTER = 'imageAfter',
  BUTTONS = 'buttons',
}
